exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body {\r\n    padding-top: 50px;    \r\n    padding-bottom: 70px;\r\n    background-color: #fff;\r\n    color: #676a6c;\r\n    font-family: helvetica,arial,sans-serif;\r\n}\r\n\r\n.navbar-brand {\r\n    padding: 0 15px;\r\n}\r\n\r\n.logo-name {\r\n    margin-left: -40px;\r\n}\r\n\r\n.footer{\r\n    position: fixed;        \r\n}\r\n\r\n.small-news-view {\r\n    height: 200px;\r\n    overflow: hidden;\r\n    white-space: pre-wrap;\r\n}\r\n\r\n.navbar-default .nav > li > a:hover, .navbar-default .nav > li > a:focus {\r\n    background-color: #E7E7E7;\r\n    color: #555;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"sourceMap":false,"importLoaders":1}!./~/postcss-loader!./src/content/styles.css
// module id = 790
// module chunks = 2